









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CharacterFaceSelector extends Vue {
  @Prop({ required: true }) faces!: string[];
  @Prop() value?: string;
}
